import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Loading } from "@/components/common";
import { Card } from "@/components/ui/card";
import { User } from "lucide-react";

function Row({ label, value }) {
  return (
    <div className="flex justify-between gap-4 py-2.5 border-b border-slate-50 last:border-0">
      <span className="text-sm text-slate-500">{label}</span>
      <span className="text-sm font-medium text-navy text-right">{value || "—"}</span>
    </div>
  );
}

export default function MyProfile() {
  const { data, isLoading } = useQuery({ queryKey: ["myProfile"], queryFn: async () => (await api.get("/my/profile")).data });
  if (isLoading || !data) return <Loading />;
  const i = data.identity || {}, e = data.employment || {}, s = data.statutory || {};

  return (
    <div>
      <PageHeader overline="Personal" title="My Profile" icon={User}
        subtitle="Your current information. To correct anything, use Request Correction." />
      <div className="grid lg:grid-cols-2 gap-4" data-testid="my-profile">
        <Card className="p-6 border-slate-200 shadow-none">
          <h3 className="font-serif-display text-xl text-navy mb-3">Identity</h3>
          <Row label="Employee ID" value={data.employee_id} />
          <Row label="Full Name" value={i.name} />
          <Row label="Date of Birth" value={i.dob} />
          <Row label="Gender" value={i.gender} />
          <Row label="Blood Group" value={i.blood_group} />
          <Row label="Mobile" value={i.mobile} />
          <Row label="Personal Email" value={i.personal_email} />
          <Row label="Emergency Contact" value={i.emergency_contact_name && `${i.emergency_contact_name} · ${i.emergency_contact_number}`} />
        </Card>
        <Card className="p-6 border-slate-200 shadow-none">
          <h3 className="font-serif-display text-xl text-navy mb-3">Employment</h3>
          <Row label="Designation" value={data.designation_title} />
          <Row label="Position" value={e.position} />
          <Row label="Department" value={data.department_name} />
          <Row label="Grade" value={e.salary_grade} />
          <Row label="Employment Type" value={e.employee_type} />
          <Row label="Status" value={e.employment_status} />
          <Row label="Reporting Officer" value={data.reporting_manager_name} />
          <Row label="Additional Charge" value={e.additional_charge} />
          <Row label="Date of Joining" value={e.doj} />
          <Row label="Project / Site" value={e.project_site} />
        </Card>
        <Card className="p-6 border-slate-200 shadow-none lg:col-span-2">
          <h3 className="font-serif-display text-xl text-navy mb-3">Statutory (masked)</h3>
          <div className="grid sm:grid-cols-2 gap-x-8">
            <Row label="PAN" value={s.pan} />
            <Row label="UAN" value={s.uan} />
            <Row label="Bank Account" value={s.bank_account} />
            <Row label="PF Applicable" value={s.pf_applicable ? "Yes" : "No"} />
          </div>
        </Card>
      </div>
    </div>
  );
}
